<template>
  <div>
    <div class="nav">
      <div
        v-for="(item, index) in nav"
        :key="index"
        class="navItem"
        @click="navClick(index)"
      >
        <div class="navItem-name">{{ item.name }}</div>
        <div class="nav-underline" v-if="index == navIndex"></div>
      </div>
    </div>

    <!-- 提醒 -->
    <div class="remind">
      <div class="flex flex-center">
        <img class="remind-img" src="../assets/imgs/cusBg.png" alt="" />
        <div>
          <div class="remind-title">端午节到店抽奖</div>
          <div class="flex flex-center">
            <div
              class="remind-label"
              v-for="(item, index) in [0, 1]"
              :key="index"
            >
              长期
            </div>
          </div>
          <div class="remind-time">
            发布时间 2022.06.30 20:00
          </div>
          <div class="remind-time">
            截止时间 2022.06.30 20:00
          </div>
        </div>
      </div>
      <div class="remind-bottom flex flex-center">
        <div
          class="flex-item_center remind-bottom_item"
          style="border-right:1px solid #ededf7;"
        >
          <img src="../assets/imgs/setDetail.png" alt="" />
          <div>查看详情</div>
        </div>
        <div class="flex-item_center remind-bottom_item">
          <img src="../assets/imgs/setShare.png" alt="" />
          <div>分享</div>
        </div>
      </div>
    </div>

    <!-- 优惠券 -->
    <div class="coupon flex flex-center rel">
      <div class="flex flex-center column">
        <div class="coupon-money flex">
          <div class="coupon-money_icon">￥</div>
          <div class="coupon-money_monry">600</div>
        </div>
        <div class="coupon-money_text">满500元可用</div>
      </div>
      <div>
        <div class="coupon-title">券名称券名称</div>
        <div class="coupon-text">指定哪家门店可用</div>
        <div class="coupon-time">
          有效期至: 2022.08.20
        </div>
      </div>
      <div class="flex flex-center coupon-detailBtn abs">
        <div>详情</div>
        <img class="coupon-img" src="../assets/imgs/arrow.png" alt="" />
      </div>
      <!-- 新到 -->
      <!-- <div class="coupon-new flex-item_center">新到</div> -->
      <!-- 将过期 -->
      <div class="coupon-overdue flex-item_center">将过期</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nav: [{ name: "提醒" }, { name: "签到" }, { name: "优惠券" }],
      navIndex: 0,
    };
  },
  methods: {
    navClick(index) {
      this.navIndex = index;
    },
  },
};
</script>

<style scoped>
.nav {
  width: 100%;
  padding: 0 111px 0 127px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
  font-size: 30px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #7d8393;
  background: #fff;
}

.navItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: 100px;
}

.navItem-name {
  margin-top: 34px;
}
.nav-underline {
  width: 91px;
  height: 6px;
  background: #0558f4;
  border-radius: 3px 3px 3px 3px;
  bottom: 0;
  position: absolute;
}

.remind {
  width: 690px;
  margin: 24px auto;
  background: #fff;
  border-radius: 24px;
  padding: 30px 0 0 0;
}

.remind-img {
  width: 185px;
  height: 185px;
  margin: 0 24px;
}

.remind-title {
  font-size: 30px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #101f48;
  margin: 0 0 15px 0;
}

.remind-label {
  padding: 3px 21px;
  font-size: 22px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #0558f4;
  background: #edf3ff;
  margin: 0 16px 11px 0;
}

.remind-time {
  font-size: 24px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #7d8393;
  margin-top: 8px;
}

.remind-bottom {
  margin-top: 46px;
  height: 81px;
  width: 100%;

  border-top: 1px solid #ededf7;
}

.remind-bottom_item {
  width: 50%;
  height: 81px;
  font-size: 28px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #0558f4;
}

.remind-bottom_item img {
  width: 26px;
  height: 26px;
  margin-right: 8px;
}

.coupon {
  width: 686px;
  height: 224px;
  margin: 24px auto;
  background: url("https://super-store-web.oss-cn-hangzhou.aliyuncs.com/img/Coupon.png");
  background-size: 100% 100%;
}

.coupon-money {
  width: 224px;
  height: 100%;
  align-items: flex-end;
}

.coupon-money_icon {
  font-size: 40px;
  font-family: Akrobat-Bold-, Akrobat-Bold;
  font-weight: normal;
  color: #101f48;
}

.coupon-money_monry {
  margin-top: 12px;
  font-size: 80px;
  font-family: Akrobat-Bold-, Akrobat-Bold;
  font-weight: normal;
  color: #101f48;
}

.coupon-title {
  font-size: 30px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #101f48;
}

.coupon-text {
  font-size: 24px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #383838;
  padding: 10px 0 49px 0;
}

.coupon-time {
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #383838;
}

.coupon-img {
  width: 12px;
  height: 20px;
  margin-left: 10px;
}

.coupon-detailBtn {
  right: 30px;
}

.coupon-new {
  width: 97px;
  height: 41px;
  background: #ff7c09;
  border-radius: 0px 16px 0px 16px;
  position: absolute;
  top: 0;
  right: 0;
  font-size: 22px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}

.coupon-overdue {
  width: 97px;
  height: 41px;
  background: #0558f4;
  border-radius: 0px 16px 0px 16px;
  position: absolute;
  top: 0;
  right: 0;
  font-size: 22px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
</style>
